module.exports = __webpack_public_path__ + "img/btn_menu_all.88945da3.png";